<!-- Created by henian.xu on 2020/4/10. -->

<template>
    <Page>
        <PageBar class="pa-l pa-r">
            <span>用时: {{answerTime}}</span>
            <span>成绩: {{certExamApplyPaper.examScore}} 分</span>
            <!--<XButton
                label="交卷"
                theme="main"
                radius="all"
                @click="()=>{onSubmit()}"
            />-->
        </PageBar>
        <Container fill>
            <div class="cat-name-path">{{certCatNameAndTypePath}}</div>
            <TopicList
                ref="topicList"
                v-if="isActivated && questionList && questionList.length"
                :data="currentQuestionList"
                v-model="answer"
                :index="swiperActiveIndex"
                :start-index="currentQuestionStartIndex"
                @index-change="onTopicListIndexChange"
                is-analysis
            />
            <div
                v-else
                class="loading ta-c pa-a ma-tb"
            >
                <XImage
                    :src="$loadingIcon"
                    width="20%"
                ></XImage>
            </div>
        </Container>
        <PageBar
            position="bottom"
            class="pa-l pa-r"
        >
            <XButton
                label="上一题"
                theme="success"
                radius="all"
                :disabled="!topicListIndex"
                @click="onPrev"
            ></XButton>
            <AnswerCard
                :data="questionList"
                :value="answer"
                :index="topicListIndex"
                is-analysis
                @index-change="onIndexChange"
            />
            <XButton
                label="下一题"
                theme="success"
                radius="all"
                :disabled="topicListIndex+1 === questionListLength"
                @click="onNext"
            ></XButton>
        </PageBar>
    </Page>
</template>

<script>
// import { formatDuration } from 'utils/index';

import { refMixin } from 'packages/mixins';
import { isDef } from 'utils/index';

export default {
    name: 'PaperPage',
    mixins: [refMixin],
    data() {
        return {
            paperId: this.$route.params.id,
            defaultPageSize: 10,
            topicListIndex: 0,
            swiperActiveIndex: 0,
            answer: [],
            detail: {},
            isActivated: false,
        };
    },
    computed: {
        certExam() {
            return this.detail.certExam || {};
        },
        certExamApplyPaper() {
            return this.detail.certExamApplyPaper || {};
        },
        overTime() {
            return this.certExamApplyPaper.overTime || 0;
        },
        questionList() {
            return this.certExamApplyPaper.questionList || [];
        },
        halfDefaultPageSize() {
            return ~~(this.defaultPageSize / 2);
        },
        currentQuestionStartIndex() {
            const { topicListIndex, halfDefaultPageSize } = this;
            return Math.max(topicListIndex - halfDefaultPageSize, 0);
        },
        currentQuestionList() {
            const { defaultPageSize, currentQuestionStartIndex } = this;
            const index = currentQuestionStartIndex;
            if (!this.questionList) return null;
            const questionList = [...this.questionList];
            return questionList.splice(index, defaultPageSize);
        },
        questionListLength() {
            const { questionList } = this;
            return (questionList && questionList.length) || 0;
        },
        questionListTem() {
            const { currentQuestionList } = this;
            if (!currentQuestionList) return [];
            return currentQuestionList.map(item => {
                if (!item) return '';
                return item.id;
            });
        },
        answerTime() {
            const { finishTime, beginTime } = this.certExamApplyPaper;
            const millisecond = finishTime - beginTime;
            if (!millisecond || millisecond <= 0) return '00:00';
            return this.$utils.formatDuration(millisecond);
        },
        certCatNameAndTypePath() {
            const { certCatNamePath, certExamTypeName } = this.certExam;
            if (!certCatNamePath) return '';
            return `${certCatNamePath}>${certExamTypeName}`;
        },
    },
    watch: {},
    methods: {
        async getPaperDetail() {
            const { data } = await this.$api.Member.Ce.CertExamPaper.paperDetail({
                certExamApplyPaperId: this.paperId,
            });
            const { certExamApplyPaper } = data;
            const { questionList } = certExamApplyPaper;
            this.answer = questionList.map(item => {
                const { id, selectOption } = item;
                if (!isDef(selectOption)) return null;
                return {
                    id,
                    selectOption: selectOption || 0,
                    isConfirm: true,
                };
            });
            this.detail = data;
        },
        async onIndexChange(val) {
            const topicList = await this.getRefsChildren('topicList');
            const { halfDefaultPageSize } = this;
            this.topicListIndex = val;
            if (this.topicListIndex < halfDefaultPageSize) {
                this.swiperActiveIndex = this.topicListIndex;
                topicList.slideTo(this.swiperActiveIndex, 0, false);
            } else {
                this.swiperActiveIndex = halfDefaultPageSize;
                topicList.slideTo(halfDefaultPageSize, 0, false);
            }
        },
        onPrev() {
            if (!this.questionListLength) return;
            this.topicListIndex -= this.topicListIndex > 0 ? 1 : 0;
            this.onIndexChange(this.topicListIndex);
        },
        onNext() {
            if (!this.questionListLength) return;
            this.topicListIndex += this.topicListIndex < this.questionListLength - 1 ? 1 : 0;
            this.onIndexChange(this.topicListIndex);
        },
        async onTopicListIndexChange(activeIndex) {
            await this.$nextTick();
            const {
                swiperActiveIndex,
                topicListIndex,
                halfDefaultPageSize,
                questionListLength,
                // add
            } = this;
            const offsetIndex = activeIndex - swiperActiveIndex;
            this.topicListIndex = Math.min(Math.max(topicListIndex + offsetIndex, 0), questionListLength);
            if (this.topicListIndex < halfDefaultPageSize) {
                this.swiperActiveIndex = this.topicListIndex;
            } else {
                this.swiperActiveIndex = halfDefaultPageSize;
                const topicList = await this.getRefsChildren('topicList');
                topicList.slideTo(halfDefaultPageSize);
            }
        },
    },
    async created() {
        this.getPaperDetail();
    },
    beforeDestroy() {},
    activated() {
        setTimeout(() => {
            this.isActivated = true;
        }, 500);
    },
};
</script>

<style lang="scss">
</style>
